// format amount with decimal places
export default function currFormat(number, places = 0) {
  number = parseFloat(number).toFixed(places)
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
  